import { render, staticRenderFns } from "./r-color-picker.vue?vue&type=template&id=0a64cc4c"
import script from "./r-color-picker.vue?vue&type=script&lang=js"
export * from "./r-color-picker.vue?vue&type=script&lang=js"
import style0 from "./r-color-picker.vue?vue&type=style&index=0&id=0a64cc4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports